module.exports = __webpack_public_path__ + "img/dot.8e76f5fd.svg";